/* eslint semi:0 */
import React from 'react'


function getClassNames({ blockName, icon, }){
  const baseClass = `${ blockName }__item`
  const modifierClass = `${ blockName }__item--${ icon }`
  return `${ baseClass } ${ modifierClass }`
}

export default function ShareButton({ blockName, href, icon, title, triggerAnalyticsFluxAction, }){
  const className = getClassNames({ blockName, icon, })
  const shareButtonAttrs = {
    href,
    title,
    className,
    rel: 'noopener',
    target: '_blank',
    onClick: triggerAnalyticsFluxAction.part(this),
  }
  return <a { ...shareButtonAttrs } />
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/components/shareButton.js